import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { isAuthAdmin } from "../../../../services/auth";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Icon } from "semantic-ui-react";
import {
  ContainerInputSearch,
  Input,
  SemanticTable,
  LinkRedirect,
  SemanticButton,
  StyledButton,
} from "./styles";

const Formulario = () => {
  const [eventos, setEventos] = useState([]);
  const [eventosFiltrados, setEventosFiltrados] = useState([]);

  useEffect(() => {
    listarEventos();
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const listarEventos = async () => {
    try {
      const response = await api.get(`/eventos`);
      const eventosAux = response.data;
      let logs = { local: "eventos", texto: `listou os eventos` };
      await api.post("system_logs", { acao: JSON.stringify(logs) });

      const now = new Date();
      const timezone = 3600000 * (now.getTimezoneOffset() / 60);

      eventosAux.map((evento) => {
        const inicioUTC = new Date(evento.data_inicio);
        const inicioTimezone = inicioUTC - timezone;
        const dataInicio = new Date(inicioTimezone);

        const finalUTC = new Date(evento.data_final);
        const finalTimezone = finalUTC - timezone;
        const dataFinal = new Date(finalTimezone);

        evento.data_inicio = dataInicio.toString();
        evento.data_final = dataFinal.toString();
      });

      setEventos(eventosAux);
      setEventosFiltrados(eventosAux);
    } catch (err) {
      if (err) {
        toast.error(
          "Seu login expirou, por gentileza, realize o mesmo novamente",
          {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      }
    }
  };

  async function filtrarEventos(inputValue) {
    if (inputValue.target.value === "") {
      setEventosFiltrados(eventos);
      return;
    }

    const eventosValue = eventos.filter(
      (data) =>
        data.titulo
          .toLowerCase()
          .indexOf(inputValue.target.value.toLowerCase()) > -1
    );

    setEventosFiltrados(eventosValue);
  }

  async function goToCreateEvento() {
    window.location.href = "/admin/eventos/criar";
  }

  async function deleteEvento(id) {
    await api
      .delete(`/admin/eventos/excluir/${id}`)
      .then((res) => {
        toast.success("Registro excluído!", {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch((err) => {
        console.error(err);
        toast.error("Problema encontrado!", {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  }

  return (
    <>
      <ContainerInputSearch className="ui fluid left icon input">
        <Input
          type="search"
          placeholder="Pesquisar evento"
          onChange={(e) => filtrarEventos(e)}
        />
        <Icon name="search icon" />
        <StyledButton onClick={goToCreateEvento}>
          <i class="plus icon"></i> Criar Evento
        </StyledButton>
      </ContainerInputSearch>

      <SemanticTable size="big" celled>
        <SemanticTable.Header>
          <SemanticTable.Row>
            <SemanticTable.HeaderCell>ID</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>Evento</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>Data de ínicio</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>Data de término</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>URL</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>
              Modelo do e-mail
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
          </SemanticTable.Row>
        </SemanticTable.Header>

        <SemanticTable.Body>
          {eventosFiltrados.map((evento) => (
            <SemanticTable.Row>
              <SemanticTable.Cell> {evento.id} </SemanticTable.Cell>
              <SemanticTable.Cell> {evento.titulo} </SemanticTable.Cell>
              <SemanticTable.Cell> {evento.data_inicio} </SemanticTable.Cell>
              <SemanticTable.Cell> {evento.data_final} </SemanticTable.Cell>
              <SemanticTable.Cell> {evento.url_evento} </SemanticTable.Cell>
              <SemanticTable.Cell> {evento.modelo_email} </SemanticTable.Cell>
              <SemanticTable.Cell>
                <LinkRedirect to={`eventos/editar/${evento.id}`}>
                  <SemanticButton
                    title="Editar Evento"
                    icon="edit icon"
                    info="edit"
                  />
                </LinkRedirect>
                <LinkRedirect
                  to={`/admin/eventos/indicacoes?id_evento=${evento.id}`}
                >
                  <SemanticButton
                    title="Ver indicações do Evento"
                    icon="edit icon"
                    info="edit"
                  />
                </LinkRedirect>
                <LinkRedirect
                  to={`/admin/inscricoes-eventos/enviar-emails?id_evento=${evento.id}`}
                >
                  <SemanticButton
                    title="Enviar emails do Evento"
                    icon="send icon"
                    info="send"
                  />
                </LinkRedirect>
                <SemanticButton
                  onClick={() => deleteEvento(evento.id)}
                  title="Excluir Evento"
                  icon="delete icon"
                  info="delete"
                />
              </SemanticTable.Cell>
            </SemanticTable.Row>
          ))}
        </SemanticTable.Body>
      </SemanticTable>
    </>
  );
};

export default Formulario;
